// extracted by mini-css-extract-plugin
export default {"heading_wrapper":"TitleWrapper_heading_wrapper__OwwqB","title":"TitleWrapper_title__QofFf","subtitle":"TitleWrapper_subtitle__QgYUu"};